import ActionsForm from '@/shared/mixins/actionsForm'
import data from './form-air'
import CountryRepository from '@/shared/http/repositories/geo/country.js'
import StateRepository from '@/shared/http/repositories/geo/state.js'
import CityRepository from '@/shared/http/repositories/geo/city.js'
import ForecastTermRepository from '@/shared/http/repositories/business/forecastterm.js'
import { loading } from '@/shared/utils/UIHelper'

export default {
  name: 'TravelAirPlaneModal',
  mixins: [ActionsForm],
  data () {
    return {
      form: data,
      objClone: [],
      disableReturn: false
    }
  },
  mounted () {
    this.onLoadAllCountry()
    this.$emit('eventAir')
  },
  methods: {
    onLoadAllCountry () {
      loading.push()
      CountryRepository.GetAll()
        .then(Response => {
          this.form.paisOrigemFlyID.options = Response.data.data
          this.form.paisDestinoFlyID.options = Response.data.data
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    onChangeCountryEnd (e) {
      loading.push()
      StateRepository.GetAllByCountryID(e)
        .then(Response => {
          this.form.estadoDestinoFlyID.options = Response.data.data
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    verificarTypeFly (e) {
      if (e === 1) {
        this.disableReturn = true
        this.form.dataFimVoo.required = false
        this.form.dataFimVoo.value = null
      } else {
        this.disableReturn = false
        this.form.dataFimVoo.required = true
      }
    },
    onChangeStateEnd (e) {
      loading.push()
      CityRepository.GetAllByStateID(e)
        .then(Response => {
          this.form.cidadeDestinoFlyId.options = Response.data.data
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    onLoadClone (obj) {
      loading.push()
      ForecastTermRepository.GetDespesaFly(obj.id)
        .then(Response => {
          this.form.paisOrigemFlyID.value = Response.data.cidadeOrigem.estado.paisID
          this.onChangeCountryStart(Response.data.cidadeOrigem.estado.paisID)
          this.form.estadoOrigemFlyID.value = Response.data.cidadeOrigem.estadoID
          this.onChangeStateStart(Response.data.cidadeOrigem.estadoID)
          this.form.cidadeOrigemFlyId.value = Response.data.cidadeIdOrigemFlyId
          this.form.paisDestinoFlyID.value = Response.data.cidadeDestino.estado.paisID
          this.onChangeCountryEnd(Response.data.cidadeDestino.estado.paisID)
          this.form.estadoDestinoFlyID.value = Response.data.cidadeDestino.estadoID
          this.onChangeStateEnd(Response.data.cidadeDestino.estadoID)
          this.form.cidadeDestinoFlyId.value = Response.data.cidadeDestinoFlyId
          this.objClone = Response.data
          this.form.dataDespesa.value = Response.data.dataDespesa
          this.form.quantidade.value = Response.data.quantidade
          this.form.dataInicioVoo.value = Response.data.dataSaidaFly
          this.form.dataFimVoo.value = Response.data.dataRetornaFly
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
        })
    },
    onChangeCountryStart (e) {
      loading.push()
      StateRepository.GetAllByCountryID(e)
        .then(Response => {
          loading.pop()
          this.form.estadoOrigemFlyID.options = Response.data.data
        })
        .catch(Error => loading.pop())
    },
    onChangeStateStart (e) {
      loading.push()
      CityRepository.GetAllByStateID(e)
        .then(Response => {
          this.form.cidadeOrigemFlyId.options = Response.data.data
          loading.pop()
        })
        .catch(Error => loading.pop())
    }

  }

}



// WEBPACK FOOTER //
// ./src/views/private/travelreimbursement/components/TravelAirPlaneModal/TravelAirPlaneModal.js